(function () {
    'use strict';

    angular.module('app').factory('CustomPreferencesService', CustomPreferencesService);

    CustomPreferencesService.$inject = ['$rootScope', 'API', '$filter', 'BusinessService'];

    function CustomPreferencesService($rootScope, API, $filter, BusinessService) {
        var service = {};

        service.dateFormats = [
            {
                title: 'DateFormat#shortDate',
                value: 'shortDate'
            },
            {
                title: 'dd.MM.yyyy',
                value: 'dd.MM.yyyy'
            },
            {
                title: 'MM.dd.yyyy',
                value: 'MM.dd.yyyy'
            },
            {
                title: 'dd/MM/yyyy',
                value: 'dd/MM/yyyy'
            },
            {
                title: 'MM/dd/yyyy',
                value: 'MM/dd/yyyy'
            },
            {
                title: 'yyyyMMdd',
                value: 'yyyyMMdd'
            },
            {
                title: 'ddMMyyyy',
                value: 'ddMMyyyy'
            },
            {
                title: 'MMddyyyy',
                value: 'MMddyyyy'
            }
        ];

        service.addBlankColumns = function (columnsPreset) {
            columnsPreset = angular.copy(columnsPreset);
            columnsPreset.forEach(function (col, index) {
                col.data.push({
                    value: 'blank_' + index,
                    onlyForExport: true,
                    text: 'Blank column for export',
                    visible: false
                });
            });
            return columnsPreset;
        };

        function getUniqueColumnsFields(columns) {
            var colObj = {};
            columns.forEach(function (currentValue) {
                currentValue.data.forEach(function (value) {
                    colObj[value.value] = value.visible;
                });
            });
            return colObj;
        }

        function isArrayEqual(firstArray, secondArray) {
            var alphabeticalSort = function (a, b) {
                return a.localeCompare(b);
            };
            firstArray = firstArray.sort(alphabeticalSort);
            secondArray = secondArray.sort(alphabeticalSort);
            return firstArray.length === secondArray.length && firstArray.every(function (v, i) {
                return v === secondArray[i];
            });
        }

        /**
         * Возвращает объект с настройками колонок без поля с переводом
         * @param tableColumns - объект с настройками
         * @returns {*}
         */
        function getColsWOTranslations(tableColumns) {
            var cols = angular.copy(tableColumns);
            return cols.map(function (col) {
                col.data = col.data.map(function (val) {
                    return {
                        value: val.value,
                        visible: val.visible,
                        isDate: val.isDate,
                        dateFormat: val.isDate ? val.dateFormat || 'shortDate' : undefined
                    };
                });
                return {
                    visible: col.visible,
                    data: col.data
                };
            });
        }

        service.saveCustomPreference = saveCustomPreference;

        /**
         * Сохранение настроек колонок для таблицы
         * @param paramKey - уникальный идентификатор таблицы
         * @param preferences - объект с настройками который нужно сохранить
         * @param preferences.exportHeaders - признак, нужно ли экспортировать заголовки
         * @param preferences.tableColumns - колонки
         * @returns {Promise<unknown>}
         */
        function saveCustomPreference(paramKey, preferences) {
            var editColsParams = {
                name: paramKey,
                value: {
                    exportHeaders: preferences.exportHeaders != null ? preferences.exportHeaders : true,
                    columns: getColsWOTranslations(preferences.tableColumns)
                }
            };
            return new Promise(function (resolve, reject) {
                BusinessService.EditCustomPreference(editColsParams, function (success, data) {
                    if (success) {
                        resolve(data.value);
                    } else {
                        reject();
                    }
                });
            });
        }

        /**
         * Загрузка и инициализация настроек колонок
         * @param paramKey - уникальный идентификатор таблицы
         * @param columnsPreset - пресет настроек колонок
         * @param exportHeaders - признак, нужно ли экспортировать заголовки
         * @returns {Promise<unknown>}
         */
        service.initTableColumns = function (paramKey, columnsPreset, exportHeaders) {
            var getColsParams = {
                name: paramKey
            };
            return new Promise(function (resolve) {
                BusinessService.GetCustomPreference(getColsParams, function (success, data) {
                    if (success) {
                        if (data.value && data.value.columns) {
                            // Если настройки уже существуют, то ищем не было ли изменений в пресете колонок
                            var table_cols = angular.copy(data.value.columns);
                            var fields_old = getUniqueColumnsFields(table_cols);
                            var fields_new = getUniqueColumnsFields(angular.copy(columnsPreset));
                            if (isArrayEqual(Object.keys(fields_new), Object.keys(fields_old))) {
                                // Если изменений в пресете не было, то добавляем переводы
                                var allPresetData = [];
                                columnsPreset.forEach(function (col) {
                                    allPresetData = allPresetData.concat(col.data);
                                });
                                table_cols.forEach(function (col, indexCol) {
                                    if (!columnsPreset[indexCol]) {
                                        col.enabled = true;
                                    } else {
                                        col.enabled = columnsPreset[indexCol].enabled;
                                    }

                                    col.data.forEach(function (dataValue) {
                                        var mainValue = allPresetData.find(function (value) {
                                            return value.value === dataValue.value;
                                        });
                                        dataValue.onlyForExport = mainValue.onlyForExport;
                                        dataValue.isDate = dataValue.isDate != null ? dataValue.isDate : mainValue.isDate;
                                        dataValue.dateFormat = dataValue.dateFormat != null ? dataValue.dateFormat : mainValue.dateFormat;
                                        dataValue.not_sortable = mainValue.not_sortable;
                                        dataValue.no_export = mainValue.no_export;
                                        dataValue.text = mainValue.text;
                                    });
                                });
                                resolve({
                                    tableColumns: table_cols,
                                    exportHeaders: data.value.exportHeaders != null ? data.value.exportHeaders : exportHeaders
                                });
                            } else {
                                // Если изменения в пресете были, то объединяем пресет и старые настройки
                                // Применяем параметры видимости для полей и для всей колонки
                                var tableColumns = angular.copy(columnsPreset);
                                tableColumns.forEach(function (col, index) {
                                    var visibleCol;
                                    col.data.forEach(function (value) {
                                        if (fields_old[value.value] != null) {
                                            value.visible = fields_old[value.value];
                                            visibleCol = visibleCol || fields_old[value.value];
                                        } else {
                                            visibleCol = visibleCol || value.visible;
                                        }
                                    });
                                    col.visible = visibleCol;
                                });
                                saveCustomPreference(paramKey, {
                                    tableColumns,
                                    exportHeaders
                                }).then(function (preferences) {
                                    resolve({tableColumns, exportHeaders});
                                }, function (error) {
                                    resolve({tableColumns: angular.copy(columnsPreset), exportHeaders: true});
                                });
                            }
                        } else {
                            // если пользователь еще не сохранял настройки, то берется пресет
                            resolve({tableColumns: angular.copy(columnsPreset), exportHeaders: true});
                        }
                    } else {
                        resolve({tableColumns: angular.copy(columnsPreset), exportHeaders: true});
                    }
                });
            });
        };

        return service;
    }

})();
